import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Field, Logo, Spinner } from '../../components/ui';
import { errMsg } from '../../services/api';
import { useAdmin, useGroup } from '../../context/AuthContext';

export default function AdminLogin() {
  const { admin, login } = useAdmin();
  const { group } = useGroup();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);

  if (admin) return <Navigate to="/admin" replace />;

  const submit = async e => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.email, form.password);
      navigate('/admin');
    } catch (err) {
      toast.error(errMsg(err, 'Login failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-900 p-4">
      <div className="w-full max-w-sm overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="bg-navy-900 px-8 py-7 text-center">
          <Logo size={84} className="mx-auto" />
          <h1 className="mt-3 font-display text-2xl font-bold text-gold-400">{group?.shortName || 'RC 2008 Batch'}</h1>
          <p className="text-sm text-navy-200">Admin panel</p>
        </div>
        <div className="h-1 bg-gold-500" />
        <form onSubmit={submit} className="space-y-4 p-8">
          <Field label="Email"><input type="email" className="input" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} autoComplete="username" /></Field>
          <Field label="Password"><input type="password" className="input" required value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} autoComplete="current-password" /></Field>
          <button disabled={busy} className="btn-primary w-full py-2.5">{busy && <Spinner size={16} />}Sign in</button>
        </form>
      </div>
    </div>
  );
}
